<template>
  <div class="card" v-show="currentCardId == 'skills'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>スキルを入力</h2>
        <p>アピールしたいスキルを入力してください</p>
      </div>
      <div class="card-content card-content-list">
        <div class="edit-form-list">
          <transition-group name="fade" tag="div">
            <div
              v-for="(skill, index) in formatData.skills"
              :key="'skill-' + index"
              class="edit-form-list-item skill-item"
            >
              <div class="skill-item-content">
                <el-input
                  class="input-lg"
                  placeholder="スキル名（例：JavaScript）"
                  title="スキル"
                  v-model="formatData.skills[index]"
                  :maxlength="MAX_SKILL_LENGTH"
                  show-word-limit
                />
              </div>
              <div class="skill-item-actions">
                <el-button
                  icon="el-icon-arrow-up"
                  circle
                  :disabled="!(index > 0 && formatData.skills.length > 1)"
                  @click="moveSkill(index, 'up')"
                />
                <el-button
                  icon="el-icon-arrow-down"
                  circle
                  :disabled="
                    !(
                      index + 1 !== formatData.skills.length &&
                      formatData.skills.length > 1
                    )
                  "
                  @click="moveSkill(index, 'down')"
                />
                <el-button icon="el-icon-delete" @click="deleteSkill(index)"
                  >削除</el-button
                >
              </div>
            </div>
          </transition-group>
          <div class="add-list-item">
            <el-button
              icon="el-icon-plus"
              circle
              type="success"
              :disabled="formatData.skills.length >= MAX_SKILLS"
              @click="addSkill()"
            />
            <p
              v-if="formatData.skills.length >= MAX_SKILLS"
              class="limit-message"
            >
              スキルは{{ MAX_SKILLS }}件まで登録できます
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  MAX_SKILLS,
  MAX_SKILL_LENGTH,
  useEnglishResumeFormatData,
  useEnglishResumeHistoriesApi
} from '@/composables/format-edit/useEnglishResumeFormatData'

defineProps<{
  currentCardId?: string
}>()

const formatData = useEnglishResumeFormatData()
const { addSkill, deleteSkill, moveSkill } = useEnglishResumeHistoriesApi()
</script>

<style scoped lang="scss">
.skill-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;
  border: 1px solid #eaeaea;
  border-radius: 6px;
  margin-bottom: 10px;
}

.skill-item-content {
  flex: 1;
}

.skill-item-actions {
  display: flex;
  gap: 5px;
  flex-shrink: 0;
}

.limit-message {
  margin: 8px 0 0;
  font-size: 0.78rem;
  color: #999;
  text-align: center;
}
</style>
